import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';

import { Observable, BehaviorSubject } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';

@Injectable()
export class HTTPStatus {
    private requestInFlight$: BehaviorSubject<boolean>;
    constructor() {
        this.requestInFlight$ = new BehaviorSubject(false);
    }

    setHttpStatus(inFlight: boolean) {
        this.requestInFlight$.next(inFlight);
    }

    getHttpStatus(): Observable<boolean> {
        return this.requestInFlight$.asObservable();
    }
}

@Injectable()
export class HttpActivityInterceptor implements HttpInterceptor {
    constructor(private status: HTTPStatus) { }

    private _strikes: number = 0;

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        this._strikes++;
        if (this._strikes === 1) this.status.setHttpStatus(true);

        return next.handle(req).pipe(
            map(event => {
                if (event instanceof HttpResponse) this._strikes--;
                return event;
            }),
            catchError(error => {
                this._strikes--;
                throw error;
            }),
            finalize(() => {
                if (this._strikes <= 0) {
                    this._strikes = 0;
                    this.status.setHttpStatus(false);
                }
            })
        )
    }
}
